type TeamCardProps = {
  name: string
  position: string
  imageUrl: string
}
export const TeamCard = ({ name, position, imageUrl }: TeamCardProps) => {
  return (
    <div className="flex w-fit flex-col gap-y-[19px]">
      <div className="border border-[rgba(212,175,55,70)] p-[19px]">
        <img
          src={imageUrl}
          className="h-[263px] w-[163px] object-cover transition-all duration-300 md:h-[331px] md:w-[263px] md:grayscale md:hover:grayscale-0"
        />
      </div>
      <div className="flex flex-col gap-y-[2.5px]">
        <h2 className="text-center font-inter text-[16px] font-bold leading-[19.36px] text-[#000000] md:text-[24px] md:leading-[29.05px] ">
          {name}
        </h2>
        <h3 className="text-center font-inter text-[10px] font-normal leading-[12.1px] md:text-[14px] md:leading-[16.94px]">
          {position}
        </h3>
      </div>
    </div>
  )
}
